import React from "react";
import { Offcanvas } from "react-bootstrap";
import PropTypes from "prop-types";

const ModalEdit = ({
  show,
  handleClose,
  title,
  children,
  size,
  placement = "end",
  type = null,
}) => {
  const mapTitles = {
    sms: "SMS",
    rcs: "RCS",
  };
  return (
    <>
      <Offcanvas
        show={show}
        placement={placement}
        backdrop="static"
        onHide={handleClose}
        className={size}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {title} {type && <span>{mapTitles[type]}</span>}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
ModalEdit.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string,
  placement: PropTypes.string,
  type: PropTypes.string,
};
export default ModalEdit;
